export const PALETTE = [
  "#F4A9A8",
  "#A8D5BA",
  "#A9C9F4",
  "#F4D9A8",
  "#C9A8F4",
  "#A8F4E1",
  "#F4A8D4",
  "#B8E0A8",
];

export const colorForContact = (contact) => {
  const seed = contact.id || contact.name || "x";
  let hash = 0;
  for (let i = 0; i < seed.length; i++)
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
};

export const getInitials = (name = "") => {
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const getContactDetails = ({
  name,
  firstName,
  lastName,
  phoneNumbers,
}) => {
  const nameParts = name?.trim()?.split(/\s+/);

  return {
    fullFirstName: firstName || nameParts?.[0] || "",
    fullLastName: lastName || nameParts?.slice(1)?.join(" ") || "",
    phoneNumber:
      phoneNumbers
        ?.map(({ number }) => number)
        ?.filter(Boolean)
        ?.join(", ") || "",
  };
};
